import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { Tabs, Tab, Box } from '@mui/material';
import { withStyles } from '@mui/styles';

import TabPanel from './TabPanel';
import IconBreadcrumbs from './IconBreadcrumbs';
import { classes } from './utils';

const AntTab = withStyles(() => ({
  root: {
    textTransform: 'none',
    fontSize: 16,
  },
}))((props) => <Tab {...props} />);

const DynamicTabLayout = (props) => {
  const {
    navItems,
    children,
    navLinks = [],
    disableRipple = true,
    showBreadcrumbs = false,
    orientation = 'horizontal',
    isVertical = false,
    onTabChange = () => {},
  } = props;

  const navigate = useNavigate();
  const { currentTabs, childTab } = useParams();

  const newNavItems = navItems.map((item) => ({
    ...item,
    label: item.label
      .replace(/[&/\\#,+()$~%.'":*?<>{}]/g, 'and')
      .toLowerCase()
      .replace(/\s/g, '-'),
    subTabs: item.subTabs
      ? item.subTabs.map((ele) => ({
          ...ele,
          label: ele.label
            .replace(/[&/\\#,+()$~%.'":*?<>{}]/g, 'and')
            .toLowerCase()
            .replace(/\s/g, '-'),
        }))
      : [],
  }));
  let currentTabIndex = newNavItems.findIndex(
    (item) => item.label === currentTabs,
  );
  if (currentTabIndex === -1 || navItems[currentTabIndex]?.disabled) {
    currentTabIndex = 0;
  }
  let childTabIndex;
  if (currentTabIndex !== -1 && newNavItems[currentTabIndex]?.subTabs.length) {
    if (childTab) {
      childTabIndex = newNavItems[currentTabIndex].subTabs.findIndex(
        (ele) => ele.label === childTab,
      );
      if (
        childTabIndex === -1 ||
        navItems[currentTabIndex].subTabs[childTabIndex]?.disabled
      ) {
        childTabIndex = 0;
      }
    } else {
      childTabIndex = 0;
    }
  }

  const [activeTab, setActiveTab] = useState(currentTabIndex);

  const handleChange = async (event, newValue) => {
    if (newNavItems[newValue].disabled) return;
    setActiveTab(newValue);
    onTabChange(newNavItems[newValue].label);
  };

  useEffect(() => {
    navigate(window.location);
  }, [navigate]);

  const buildTabDetails = (tabItem) => {
    const childrenList = Array.isArray(children) ? children : [children];
    return childrenList
      .filter((item) => item)
      .map((item, index) => (
        <TabPanel
          key={index}
          index={item.props.index}
          value={navItems[activeTab].label}
          isVertical={isVertical}
        >
          <Box className="tab-layout-content p-4 ">
            {showBreadcrumbs && (
              <Box className="mb-3">
                <IconBreadcrumbs tabItem={tabItem} navLinks={navLinks} />
              </Box>
            )}
            {item}
          </Box>
        </TabPanel>
      ));
  };

  return (
    <Box
      className={!isVertical ? classes.TabLayout : classes.TabLayoutVertical}
    >
      <Box>
        <Tabs
          value={activeTab}
          orientation={orientation}
          variant="scrollable"
          scrollButtons="on"
          onChange={handleChange}
          // TabIndicatorProps={{
          //   style: { display: 'block', width: '2px' },
          // }}
          aria-label={
            isVertical ? 'Vertical tabs example' : 'basic tabs example'
          }
          className={
            !isVertical ? classes.TabBackground : classes.TabBackgroundVertical
          }
        >
          {navItems.map((tab, index) => (
            <AntTab
              disableRipple={disableRipple}
              disabled={tab.disabled}
              key={index}
              label={tab.label}
              indicatorColor="none"
              className={
                activeTab === index
                  ? !isVertical
                    ? classes.activeTab
                    : classes.verticalActiveTab
                  : !isVertical
                    ? classes.nonActiveTab
                    : classes.verticalNonActiveTab
              }
            />
          ))}
        </Tabs>
      </Box>

      {navItems.map((tab, index) => (
        <TabPanel
          key={index}
          value={activeTab}
          index={index}
          isVertical={isVertical}
        >
          <Box>{buildTabDetails(tab)}</Box>
        </TabPanel>
      ))}
    </Box>
  );
};

DynamicTabLayout.propTypes = {
  children: PropTypes.node.isRequired,
  navItems: PropTypes.arrayOf.isRequired,
  disableRipple: PropTypes.bool.isRequired,
  showBreadcrumbs: PropTypes.bool.isRequired,
  navLinks: PropTypes.arrayOf.isRequired,
  orientation: PropTypes.string.isRequired,
  isVertical: PropTypes.bool.isRequired,
  onTabChange: PropTypes.func.isRequired,
};

export default DynamicTabLayout;
